<template>
  <v-container class="container">
    <v-form ref="form" v-model="valid" lazy-validation>
      <GmapMap v-show="true" ref="map" :center="this.mapView" :zoom="15" style="width: 100%; height: 800px">
        <GmapMarker :position="this.iniPos">
        </GmapMarker>
        <GmapMarker :position="this.endPos">
        </GmapMarker>
      </GmapMap>
    </v-form>
  </v-container>
</template>
<script>
import VueTimepicker from 'vue2-timepicker/src'

export default {
  props: [
    'devices',
    'device'
  ],
  components: {
    VueTimepicker,
  },
  data() {
    return {
      map: {},
      search: '',
      valid: false,
      markers: [],
      deviceObject: {id: "", value: "", date: new Date()},
      singleSelect: false,
      marker: null,
      mapView: {lat: -0.190029, lng: -78.482114},
      expires_in: 0,
      selectedInMap: "",
      dialogReport: false,
      searched: false,
      reportType: '',
      interval: 0,
      countTimesCall: 0,
      path: [],
      colorLine: '#008000',
      iniPos: {},
      endPos: {},
      directionsService: "",
      directionsRenderer: ""
    };
  },
  watch: {},
  methods: {
    getDirectionNew(initialPosition) {
      var directionsService = new google.maps.DirectionsService;
      var directionsDisplay = new google.maps.DirectionsRenderer;
      directionsDisplay.setMap(this.$refs.map.$mapObject);
      this.$store.dispatch('getDevicesLocationTraccar', this.device.idTraccar).then(response => {
        this.iniPos = initialPosition
        this.mapView = initialPosition
        this.endPos = {
          lat: response.data.result[0].lat,
          lng: response.data.result[0].lng,
        }
        //google maps API's direction service
        function calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
          directionsService.route({
            origin: start,
            destination: destination,
            travelMode: 'DRIVING'
          }, function (response, status) {
            if (status === 'OK') {
              directionsDisplay.setDirections(response);
            } else {
              window.alert('Directions request failed due to ' + status);
            }
          });
        }
        calculateAndDisplayRoute(directionsService, directionsDisplay, this.iniPos, this.endPos);
      })
    },

    success(position) {
      this.getDirectionNew({lat: position.coords.latitude, lng: position.coords.longitude})
    }
  },
  computed: {},
  created() {

    function error(msg) {
      alert('error');
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.success, error);
    } else {
      error('not supported');
    }
  },
};
</script>

<style scoped>
.container {
  max-width: 100% !important;
  padding: 0%;
}
</style>



// WEBPACK FOOTER //
// src/components/device/mobile/DirectionMobile.vue